import * as React from 'react';
import {
  connect,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
} from '@cian/adfox-component';
import { OwnTemplates } from './OwnTemplates';
import { withAdfoxPostViewAnalytics, type InitialAdfoxAnalyticsPayload } from '@cian/postview-analytics-utils';
import { useApplicationContext } from '../../utils/applicationContext';

const AdFoxBannerComponent = connect(OwnTemplates);

type TAdFoxBannerProps = TAdFoxBannerComponentProps & {
  postViewAnalyticsData: Pick<InitialAdfoxAnalyticsPayload, 'place' | 'isSp'>;
  position?: number;
  galleryPosition?: number;
};

export const NewAdfoxBanner: React.FC<TAdFoxBannerProps> = props => {
  const [isHidden, setIsHidden] = React.useState(false);
  const { logger } = useApplicationContext();
  const { postViewAnalyticsData, position, galleryPosition, onStub, onLoad, onError, ...sharedProps } = props;

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData, containerId: string) => {
      const { bundleName } = data;

      if (bundleName === 'banner.direct') {
        setIsHidden(true);
      }

      onLoad?.(data, containerId);
    },
    [onLoad],
  );

  return React.useMemo(() => {
    if (isHidden) {
      return null;
    }

    const AdfoxWithPostView = withAdfoxPostViewAnalytics(
      AdFoxBannerComponent,
      {
        ...postViewAnalyticsData,
        position,
        galleryPosition,
      },
      {
        logger,
      },
    );

    return <AdfoxWithPostView {...sharedProps} onLoad={handleLoad} onStub={onStub} onError={onError} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHidden]);
};
